import { render } from "./VgtHeaderRow.vue?vue&type=template&id=d2c4a9ca"
import script from "./VgtHeaderRow.vue?vue&type=script&lang=js"
export * from "./VgtHeaderRow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__